import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import MYPostCodesJSON from 'src/assets/data/malaysia-postcodes.json';

export interface PostcodeResult {
  city: string;
  state: string;
  found: boolean;
}

export interface CityData {
  name: string;
  postcode: string[];
}

export interface StateData {
  name: string;
  city: CityData[];
}

export interface PostcodeData {
  state: StateData[];
}

@Injectable({
  providedIn: 'root'
})
export class PostcodeLookupService {
  private postcodeData: PostcodeData | null = null;

  constructor(private http: HttpClient) {}

  private loadPostcodeData(): Observable<PostcodeData> {
    if (this.postcodeData) {
      return of(this.postcodeData);
    }

    return of(MYPostCodesJSON).pipe(
      map(data => {
        this.postcodeData = data;
        return data;
      }),
      catchError(() => {
        console.error('Failed to load postcode data');
        return of({ state: [] } as PostcodeData);
      })
    );
  }

  lookupPostcode(postcode: string): Observable<PostcodeResult> {
    // Validate postcode format (5 digits)
    if (!postcode || !/^\d{5}$/.test(postcode)) {
      return of({ city: '', state: '', found: false });
    }

    return this.loadPostcodeData().pipe(
      map(data => {
        // Search through all states and cities
        for (const state of data.state) {
          for (const city of state.city) {
            if (city.postcode.includes(postcode)) {
              return {
                city: city.name,
                state: state.name,
                found: true
              };
            }
          }
        }

        // No match found
        return { city: '', state: '', found: false };
      })
    );
  }
} 